import { Create, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { DepartmentFormFields } from './DepartmentForm';
import { normalizeShiftTimes } from './shiftTimes';

export const DepartmentCreate = () => (
  <Create redirect="list" transform={normalizeShiftTimes}>
    <SimpleForm toolbar={<MyToolbar resource="departments" />}>
      <MyFormContainer>
        <DepartmentFormFields isCreate />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export default DepartmentCreate;
